// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"a584cfb4","251":"e5b8ad09","407":"b9541447","453":"b53fa46a","509":"32b97807","534":"1d254f6c","653":"793c745c","717":"84a273a6","723":"fb53ae29","777":"13c573ee","946":"4012f70b"}[chunkId] + ".chunk.js";
};